import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "matching-card-background" }
const _hoisted_2 = ["alt", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("picture", null, [
      _createElementVNode("img", {
        alt: _ctx.companyName,
        src: _ctx.backgroundSource
      }, null, 8, _hoisted_2)
    ])
  ]))
}